// @ts-check
import React, { FC } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import cx from 'classnames';
import classes from './AppointmentStatusBadge.module.scss';

export const statusLabelLookup = {
  unconfirmed: 'Unconfirmed',
  confirmed: 'Confirmed',
  completed: 'Completed',
  cancelled: 'Cancelled',
  no_show: 'No Show',
};

/** @type { FC<{status: string, prefix?:string}> } */
const AppointmentStatusBadge = ({ status, prefix }) => (
  <span className={cx(classes.badge, classes[status])}>
    <span className={classes.label}>
      {prefix} {statusLabelLookup[status]}
    </span>
  </span>
);

// TODO:
AppointmentStatusBadge.propTypes = {
  status: PropTypes.oneOf(Object.keys(statusLabelLookup)),
};

export default AppointmentStatusBadge;
